module.exports = __webpack_public_path__ + "38afc08c9736a1df5acd94fe049a4651.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/meredicte/meredicte-4.jpg
// module id = 330
// module chunks = 1